import { render, staticRenderFns } from "./moving-region-dialog.vue?vue&type=template&id=4c752354&"
import script from "./moving-region-dialog.vue?vue&type=script&lang=js&"
export * from "./moving-region-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports